import * as Parse from 'parse'
import { Objects } from '../../../../../server/src/shared-with-client/object-definitions'

export interface Establishment {
    id: string
    name: string
    industryAtSignUp: string | undefined
    industryList: string[]
}

export class EstablishmentService {
    constructor() {}

    async getDefaultEstablishment(userID: string | undefined): Promise<Establishment | undefined> {
        let establishment: Objects.Establishment.Parse | undefined
        if (userID) {
            const user = new Parse.User()
            user.id = userID
            establishment = await user.relation<Objects.Establishment.Parse, 'establishment'>('establishment').query().first()
        } else {
            const COLLECTION: Objects.Establishment.Collection = 'Establishment'
            establishment = await new Parse.Query<Objects.Establishment.Parse>(COLLECTION)
                // Based on the sort logic at the bottom
                .ascending('name')
                .first()
        }

        if (!establishment) {
            return undefined
        }

        const mappedEstablishment: Establishment = {
            id: establishment.id,
            name: establishment.get('name'),
            industryList: establishment.get('industryList') || [],
            industryAtSignUp: establishment.get('industryAtSignUp'),
        }

        return mappedEstablishment
    }
    async getEstablishment(id: string): Promise<Establishment | undefined> {
        const COLLECTION: Objects.Establishment.Collection = 'Establishment'
        const establishment = await new Parse.Query<Objects.Establishment.Parse>(COLLECTION).equalTo('objectId', id).first()

        if (!establishment) {
            return undefined
        }

        const mappedEstablishment: Establishment = {
            id: establishment.id,
            name: establishment.get('name'),
            industryList: establishment.get('industryList') || [],
            industryAtSignUp: establishment.get('industryAtSignUp'),
        }

        return mappedEstablishment
    }
}

// function sortEstablishments(establishments: Establishment[]) {
//     establishments.sort((e1, e2) => {
//         const nameLowercaseE1 = (e1.name || '').toLowerCase();
//         const nameLowercaseE2 = (e2.name || '').toLowerCase();
//         if (nameLowercaseE1 > nameLowercaseE2) {
//             return 1;
//         }
//         if (nameLowercaseE1 < nameLowercaseE2) {
//             return -1;
//         }
//         return 0;
//     })
// }
